import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitleCommon, {DialogCloseCommon} from "./DialogTitleCommon";
import {Loader} from "components/FormComponents/Loader/Loader";
import Box from "@mui/material/Box";
import FormValidationAlert from "components/FormComponents/Alert/FormValidationAlert";

interface Props {
  title: string;
  dialogPaperProps: any;
  loader: boolean;
  setLoader?: any;
  dialogTitle?: string;
  filelink?: string | undefined;
  open: boolean;
  dialogStyle: any;
  handleClose: () => void;
}

const ViewAttachmentDialog: React.FC<Props> = ({
  title,
  dialogPaperProps,
  loader,
  setLoader,
  filelink,
  dialogTitle,
  open,
  dialogStyle,
  handleClose,
}) => {
  return (
    <React.Fragment>
      <Dialog
        maxWidth="xl"
        PaperProps={{
          sx: dialogPaperProps,
        }}
        open={open}
        onClose={handleClose}>
        <DialogCloseCommon onClick={handleClose} />
        <DialogTitleCommon title={title ?? "View Attachment"} />
        <DialogContent sx={dialogStyle.centerTheDialogContent}>
          {loader ? <Loader open={loader} /> : <></>}
          {filelink?.split(":")[0] === "blob" ? (
            <iframe
              src={filelink}
              style={dialogStyle.iframeContent}
              onLoad={() => setLoader(false)}
            />
          ) : (
            <Box pt={1} width={"100%"}>
              {filelink && (
                <FormValidationAlert
                  severity="error"
                  message={filelink ?? ""}
                />
              )}
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default ViewAttachmentDialog;
